function moveArrayElement(array, from, to) {
  array.splice(to, 0, array.splice(from, 1)[0])
}

export function moveArrayDown(array, idx) {
  moveArrayElement(array, idx, idx + 1)
}
export function moveArrayUp(array, idx) {
  moveArrayElement(array, idx, idx - 1)
}
